/**
 * Menuaccess Reducers
 */
import {
    ALL_FEATURES,
    ADD_FEATURE,
    FEATURE_ACTION,
    EDIT_FEATURE,
    STATUS_FEATURE,
    DELETE_FEATURE,
    ALL_MENUS,
    ADD_MENU,
    MENU_ACTION,
    EDIT_MENU,
    STATUS_MENU,
    DELETE_MENU
} from 'Actions/types';

/**
 * initial auth user
 */
const INIT_STATE = {
    featurelists:[],
    menulists:[],
    loading: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case FEATURE_ACTION:
            return { ...state, loading: true };

        case ALL_FEATURES:
            return { ...state, loading: false, featurelists: action.payload };  
            
        case ADD_FEATURE:
            return { ...state, loading: false }; 
        
        case EDIT_FEATURE:
            return { ...state, loading: false };  
        
        case STATUS_FEATURE:
            return { ...state, loading: false };    
        
        case DELETE_FEATURE:
            return { ...state, loading: false };
            
        case MENU_ACTION:
            return { ...state, loading: true };

        case ALL_MENUS:
            return { ...state, loading: false, menulists: action.payload };  
            
        case ADD_MENU:
            return { ...state, loading: false }; 
        
        case EDIT_MENU:
            return { ...state, loading: false };  
        
        case STATUS_MENU:
            return { ...state, loading: false };    
        
        case DELETE_MENU:
            return { ...state, loading: false };    

        default: return { ...state };
    }
}